<template>
    <div class="send-mail">
        <router-view></router-view>

        <div class="send-mail__top"></div>
        <div class="send-mail__card">
            <div class="mail-form">
                <div class="mail-form__buttons">
                    <default-button @click="sendMail">
                        Send E-Mail
                    </default-button>
                </div>
                <div class="mail-form__inputs">
                    <input class="mail-form__input"
                           type="text"
                           v-model="mail.handAddress"
                           placeholder="adress"
                    />

                    <input class="mail-form__input"
                           type="text"
                           v-model="mail.subject"
                           placeholder="subject"
                    />

                    <textarea class="mail-form__text-area"
                              v-model="mail.bodyNoHtml"
                              placeholder="message in html form. Enter will be converted to newline."
                    ></textarea>
                </div>
            </div>
            <div class="sendMailUserListHolder">
                <div class="sendMailUserListButtons">
                    <button id="sendMailUserSelectButton" class="sendMailUserListButton" @click="select()">all</button>
                    <input class="sendMailUserSelectInput" type="text" v-model="filter"/>
                </div>
                <div class="sendMailUserList">
                    <div class="sendMailUserListItem"
                         v-for="item in userMailList"
                         :key="item.id"
                         :class="{sendMailUserListItemSelected: item.selected}"
                         @click.prevent="item.selected = !item.selected"
                         v-show="!item.hidden"
                    >
                        {{item.unum}}
                        {{item.fname}}
                        {{item.lname}}<br>
                        {{item.email}}<br>
                        <div class="sendMailUserListItemLast">
                            <p>{{item.stao}}</p>
                            <p>{{item.autlev}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';

export default {
    components: { DefaultButton },
    data() {
        return {
            mail: {
                address: '',
                handAddress: '',
                subject: '',
                body: '',
                bodyNoHtml: ''
            },
            filter: ''
        }
    },
    computed: {
        userMailList() {
            return this.$store.getters['user/userMailList'];
        }

    },
    watch: {
        filter: function() {
            let userString = '';

            if (this.filter.length > 0) {
                for (let i = 0; i < this.userMailList.length; i++) {
                    userString = this.userMailList[i].unum.toUpperCase() +
                            this.userMailList[i].fname.toUpperCase() +
                            this.userMailList[i].lname.toUpperCase() +
                            this.userMailList[i].email.toUpperCase() +
                            this.userMailList[i].stao.toUpperCase() +
                            this.userMailList[i].autlev.toUpperCase();

                    // console.log(userString.includes(this.filter.toUpperCase()));

                    if (userString.includes(this.filter.toUpperCase())) {
                        this.userMailList[i].hidden = false;
                    } else {
                        this.userMailList[i].hidden = true;
                    }
                }
            } else {
                for (let i = 0; i < this.userMailList.length; i++) {
                    this.userMailList[i].hidden = false;
                }
            }
        }
    },
    methods: {
        sendMail() {
            let to = '';

            // create the addresses
            for (let i = 0; i < this.userMailList.length; i++) {
                if (this.userMailList[i].selected) {
                    to = to + this.userMailList[i].email + ', ';
                }
            }

            // turn lines breaks into <br>
            this.mail.body = this.mail.bodyNoHtml.replace(/(?:\r\n|\r|\n)/g, '<br>');

            this.mail.address = this.mail.handAddress + '; ' + to;

            this.$store.dispatch('user/sendMailToAddress', this.mail);
        },
        select() {
            let button = document.getElementById('sendMailUserSelectButton');

            if (button.innerHTML === 'all') {
                button.innerHTML = 'none';
                for (let i = 0; i < this.userMailList.length; i++) {
                    if (!this.userMailList[i].hidden) {
                        this.userMailList[i].selected = true;
                    }
                }
            } else {
                button.innerHTML = 'all';
                for (let i = 0; i < this.userMailList.length; i++) {
                    if (!this.userMailList[i].hidden) {
                        this.userMailList[i].selected = false;
                    }
                }
            }
        }

    },
    mounted() {
        this.$store.dispatch('user/userMailList');
    }
}
</script>

<style scoped lang="scss">

    .send-mail {
        position: absolute;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: $color-white;
    }

    .send-mail__card {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .sendMailUserListHolder {
        display: flex;
        flex-direction: column;
        height: 31rem;
        width: 100%;
    }

    .sendMailUserListButtons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .sendMailUserListButton {
        font-size: 1.5rem;
        width: 100px;
    }

    .sendMailUserSelectInput {
        font-size: 1.5rem;
    }

    .sendMailUserList {
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
    }

    .sendMailUserListItem {
        display: flex;
        flex-direction: column;
        width: 100%;
        cursor: pointer;
        font-size: 1.5rem;
        border-bottom: 0.125rem solid black;
    }

    .sendMailUserListItem:active {
        background-color: $color-green;
    }

    .sendMailUserListItemLast {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .sendMailUserListItemSelected {
        background-color: $color-green;
    }

    .mail-form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 31rem;
        border-left: 0.125rem solid black;
    }

    .mail-form__buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .mail-form__inputs {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .mail-form__input {
        font-size: 1.5rem;
    }

    .mail-form__text-area {
        font-size: 1.5rem;
        resize: none;
        height: 100%;
    }

    .sendMailButton {
        font-size: 2rem;
        text-align: center;
        cursor: pointer;
        padding: 0.625rem;
    }

    .sendMailButton:hover {
        background-color: $color-gray;
    }

    .sendMailButton:active {
        background-color: $color-green;
    }

    .send-mail__top {
        height: 70px;
    }

    @include large {
        .send-mail__top {
            display: none;
        }

        .send-mail__card {
            flex-direction: row;
            @include default-shadow;
            height: 80vh;
        }

        .mail-form {
            height: 100%;
        }

        .sendMailUserListHolder {
            width: 31rem;
            height: 100%;
        }

        .send-mail {
            justify-content: center;
        }

        .sendMailUserListButtons {
            flex-direction: row;
        }
    }

    @include extra-large {
        .send-mail__card {
            @include default-shadow;
            flex-direction: row;
            height: 80vh;
        }

        .mail-form {
            height: 100%;
        }

        .sendMailUserListHolder {
            width: 31rem;
            height: 100%;
        }

        .send-mail {
            justify-content: center;
        }
    }
</style>
